<template>
  <div class="page">
    <van-nav-bar left-text="免费拿产品详情" left-arrow @click-left="goBack">
      <van-icon :name="require('@/assets/images/x2-01.png')" size="25" slot="right" @click="showSharePopup" />
    </van-nav-bar>

    <div class="top">
      <a class="help" @click="$router.push('/bo/rules')"> 如何获得礼品？点击查看> </a>
      <img src="@/assets/images/freeIcon.png" alt="" />
      <div class="desc">左右滑动选礼品，点击“免费拿”参与</div>
    </div>

    <swiper ref="mySwiper" :options="swiperOptions" @slideChange="onSwipe">
      <swiper-slide v-for="(item, index) in coupon.freeTakeDenominations" :key="index">
        <div class="swiper-item" @click="take">
          <span class="swiper-item_header">礼品 {{ index + 1 }}</span>
          <div class="swiper-item_body" v-if="coupon.type === 9">
            <div class="image-container">
              <img class="master-image" v-lazy="item.customFreeTakeProductMainPictureUrl" />
              <img v-lazy="getTagImage(item)" class="tag-image" />
            </div>
            <div class="product-info">
              <div>
                <span class="price-tag">原价</span>
                <span class="price">￥{{ item.price }}</span>
              </div>
              <div class="title">{{ item.customFreeTakeName }}</div>
            </div>
            <div class="product-desc">
              <div class="title">产品详情</div>
              <div v-html="item.mobileDescription"></div>
            </div>
          </div>
          <div class="swiper-item_body" v-else>
            <div class="ticket-container">
              <div class="ticket">
                <div class="discount">
                  {{ item.preferentialContent + couponType[coupon.type].unit }}
                </div>
                <div class="condition">满{{ item.useThreshold + couponType[coupon.type].conditionUnit }}</div>
              </div>
              <div class="ticket-footer">
                <span class="stock"> 剩余库存：{{ item.count - item.takeCount }}份 </span>
                <span class="take-count">已拿：{{ item.takeCount }}</span>
              </div>
              <img :src="getTagImage(item)" alt="" class="tag-image" />
            </div>
            <ul>
              <li>优惠券名称：{{ coupon.couponName }}</li>
              <li>使用时间：{{ coupon.startTime }} 至 {{ coupon.endTime }}</li>
              <li>优惠类型：{{ couponType[coupon.type].name }}</li>
              <li>面额：{{ item.preferentialContent + couponType[coupon.type].unit }}</li>
              <li>使用门槛：满{{ item.useThreshold + couponType[coupon.type].conditionUnit }}可用</li>
              <li>发行量：{{ item.count }}张</li>
              <li>每人限领：{{ item.restriction }}张</li>
            </ul>
          </div>
          <div class="swiper-item_footer">
            <div class="tips">注：上下滑动，了解礼品更多信息</div>
            <van-button
              :color="isActivityExpired || item.count === item.takeCount ? '#c9caca' : '#e60012'"
              :disabled="isActivityExpired || item.count === item.takeCount"
              :plain="!item.serialNumber && !isActivityExpired && !isActivityExpired && item.cont !== item.takeCount"
            >
              <div>{{ getTakeBtnText(item) }}</div>
              <div class="go-text" v-if="item.gotGift">{{ coupon.type === 9 ? '选择兑换方式 >>' : '去使用 >>' }}</div>
            </van-button>
          </div>
        </div>
      </swiper-slide>
    </swiper>

    <!-- 分享弹窗 -->
    <van-popup position="bottom" :round="true" :closeable="true" v-model="showShare">
      <div class="showSharePopup-header" v-if="coupon.freeTakeDenominations">
        <div>
          <span>已选礼品{{ activeIndex + 1 }}</span>
          <span>播满{{ currentFreeTake.shareCount }}人</span>
          <span>即可获赠</span>
        </div>
        <div class="showSharePopup-header-image-container">
          <span>礼品{{ activeIndex + 1 }}</span>
          <img src="@/assets/images/dangao.png" alt="" />
        </div>
      </div>

      <van-divider :style="{ padding: '0 12px' }" />

      <div class="showSharePopup-options-desc">邀好友帮查看：</div>
      <van-grid :icon-size="50" :border="false" :clickable="true" :square="true">
        <van-grid-item
          v-for="(item, index) in shareOptions"
          :key="index"
          :icon="item.icon"
          :text="item.name"
          @click="onShareSelect(item.name)"
        />
      </van-grid>
    </van-popup>
  </div>
</template>

<script>
import { FRONTEND_HOST } from '@/config/domainnameconstant'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/swiper-bundle.css'
import moment from 'moment'
import { getDetails, takePart } from '@/api/freeTake'

export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      productId: this.$route.query.productId,
      storeId: this.$route.query.storeId,
      activeIndex: this.$route.query.index | 0,
      swiperOptions: {
        initialSlide: this.$route.query.index | 0,
        slidesPerView: 1.49,
        centeredSlides: true,
        spaceBetween: 0,
      },
      showShare: false,
      shareOptions: [
        {
          name: '微信好友',
          icon: require('@/assets/images/popups/weixin.png'),
        },
        { name: '朋友圈', icon: require('@/assets/images/popups/friends.png') },
        { name: 'QQ', icon: require('@/assets/images/popups/qq.png') },
        // { name: 'QQ空间', icon: require('@/assets/images/popups/qqspace.png') },
        // { name: '新浪微博', icon: require('@/assets/images/popups/weibo.png') },
        { name: '复制', icon: require('@/assets/images/popups/file.png') },
      ],
      coupon: {},
      couponType: {
        7: {
          unit: '折',
          name: '折扣',
          conditionUnit: '件',
        },
        8: {
          unit: '元',
          name: '满减',
          conditionUnit: '元',
        },
      },
    }
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper
    },
    currentFreeTake() {
      return this.coupon.freeTakeDenominations[this.activeIndex]
    },
    isActivityExpired() {
      return this.coupon && moment().isAfter(this.coupon.endTime)
    },
  },
  created() {
    const couponId = this.$route.query.couponId

    if (!couponId) {
      console.error('缺少couponId参数')
      return
    }

    getDetails(couponId).then(res => {
      if (res.data.code === 200) {
        this.coupon = res.data.data
      }
    })
  },
  methods: {
    /**
     * 返回
     */
    goBack() {
      if (this.$getIsApp()) {
        this.$callApp('Android', 'GoBackAppMethod', '')
        this.$callApp('iOS', 'GoBackAppMethod', '')
      } else {
        this.$router.go(-1)
      }
    },

    /**
     * 弹窗分享弹窗
     */
    showSharePopup() {
      if (this.currentFreeTake.serialNumber) {
        this.showShare = true
      } else {
        const loading = this.$toast.loading({
          overlay: true,
          forbidClick: true,
          duration: 0,
          message: '请稍后...',
        })
        takePart({
          denominationId: this.currentFreeTake.id,
          storeId: this.storeId,
        })
          .then(res => {
            this.currentFreeTake.serialNumber = res.data.data
            this.showShare = true
          })
          .finally(() => loading.clear())
      }
    },

    /**
     * 参与免费拿
     */
    take() {
      if (this.currentFreeTake.gotGift) {
        if (this.coupon.type === 9) {
          this.$router.push(`/bo/success?orderId=${this.currentFreeTake.orderId}`)
        } else {
          // 去我的券页面
          this.$router.push('/mycoupon')
        }
      }

      this.showSharePopup()
    },

    /**
     * 分享
     */
    onShareSelect(option) {
      const isProduct = this.coupon.type === 9

      const shareUrl = `${FRONTEND_HOST}/mall/detail?id=${this.productId}&storeId=${this.storeId}&serialNumber=${this.currentFreeTake.serialNumber}`

      const SharingData = {
        shareImgUrl: isProduct ? this.currentFreeTake.customFreeTakeProductMainPictureUrl : '',
        shareTitle: isProduct ? this.currentFreeTake.customFreeTakeName : this.coupon.couponName,
        shareDes: this.coupon.couponName,
        shareUrl,
      }

      console.log('sharingData', SharingData)

      let method, data
      if (option === '微信好友') {
        method = 'ShareToWechatSessionMethod'
        data = SharingData
      } else if (option === '朋友圈') {
        method = 'ShareToWechatTimeLineMethod'
        data = SharingData
      } else if (option === 'QQ') {
        method = 'ShareToQQMethod'
        data = SharingData
      } else if (option === '复制') {
        method = 'CopyMethod'
        data = shareUrl
      }

      this.$callApp('Android', method, JSON.stringify(data))
      this.$callApp('iOS', method, data)

      this.showShare = false
    },

    /**
     * 左右切换礼品
     */
    onSwipe(swipe) {
      this.activeIndex = swipe.activeIndex
    },

    /**
     * 获取免费状态图片
     */
    getTagImage(item) {
      if (this.isActivityExpired) {
        return require('@/assets/images/free/failBtn.png')
      }
      if (item.gotGift) {
        return require('@/assets/images/free/successBtn.png')
      }
      if (item.takeCount === item.count) {
        return require('@/assets/images/free/finishBtn.png')
      }
      return ''
    },

    /**
     * 获取免费按钮文字
     */
    getTakeBtnText(item) {
      if (this.isActivityExpired) {
        return `播${item.shareCount}人 已查看${item.sharedCount || 0}人`
      }
      if (item.gotGift) {
        return `播${item.shareCount}人 已查看${item.sharedCount || 0}人   已成功`
      }
      if (item.serialNumber && !this.isActivityExpired) {
        return `播${item.shareCount}人 已查看${item.sharedCount || 0}人    继续播`
      }
      if (!item.serialNumber && item.takeCount < item.count) {
        return `播${item.shareCount}人  免费拿`
      }
      if (item.serialNumber && item.takeCount === item.count) {
        return `播${item.shareCount}人  已查看${item.sharedCount || 0}  已拿完`
      }
      if (!item.serialNumber && item.takeCount === item.count) {
        return `播${item.shareCount}人  已拿完`
      }
    },
  },
}
</script>

<style lang="less" scoped>
.page {
  height: 100vh;
  background-color: #efefef;

  /deep/ .van-icon-arrow-left,
  /deep/ .van-nav-bar__text {
    font-size: 18px;
    color: #3d3d3d;
  }

  .top {
    font-size: 12px;
    text-align: center;
    position: relative;

    .help {
      position: absolute;
      top: 17px;
      right: 16px;
      color: #f94b4b;
    }

    img {
      margin-top: 51px;
      width: 60%;
    }

    .desc {
      color: #595757;
      margin: 13px 0 20px 0;
    }
  }

  .swiper-slide {
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  }

  .swiper-slide:not(.swiper-slide-active) {
    transition: 500ms;
    transform: scale(0.85);
  }

  .swiper-item {
    text-align: center;
    overflow: hidden;
    background-color: #fff;

    .swiper-item_header {
      display: inline-block;
      font-size: 12px;
      font-weight: 400;
      padding: 4px 13px;
      margin: 8px 0;
      background-color: #f94b4b;
      color: #fff;
    }

    .swiper-item_body {
      height: 330px;
      padding: 0 10px;
      overflow: auto;

      .image-container {
        width: 100%;
        height: 224px;
        margin: 0 auto;
        border: 1px solid #ececec;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        overflow: hidden;

        .master-image {
          width: 100%;
        }
      }

      .product-info {
        color: #000;
        text-align: left;
        font-size: 10px;

        & > * {
          margin-top: 10px;
        }

        .price {
          font-size: 16px;
        }

        .price-tag {
          padding: 4px 5px;
          margin-right: 5px;
          color: #fff;
          border-radius: 4px;
          background-color: #ffb54a;
        }
      }

      .product-desc {
        overflow: hidden;

        .title {
          margin-top: 10px;
          padding-top: 10px;
          font-size: 10px;
          color: #020202;
          font-weight: 600;
          border-top: 1px solid #e4e5e5;
        }

        /deep/ img {
          max-width: 100%;
        }
      }

      .ticket-container {
        position: relative;

        .ticket {
          height: 120px;
          padding-left: 20px;
          color: #fff;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: flex-start;
          background-image: linear-gradient(to right, #ff6600, #ffb340);

          .discount {
            font-size: 15px;
            font-weight: 600;
          }

          .condition {
            font-size: 12px;
          }
        }

        .ticket-footer {
          padding: 10px 0;
          width: 100%;
          display: flex;
          justify-content: space-between;
          font-size: 10px;
          border-bottom: 1px solid #e4e5e5;

          .stock {
            color: #000;
          }

          .take-count {
            color: #898989;
          }
        }
      }

      .tag-image {
        width: 98px;
        position: absolute;
        right: 4px;
        bottom: 4px;
      }

      ul > li {
        font-size: 10px;
        color: #595757;
        text-align: left;
        padding-bottom: 10px;

        &:first-child {
          padding-top: 7px;
        }
      }
    }

    .swiper-item_footer {
      .tips {
        width: 100%;
        color: #595757;
        background-color: #dcdddd;
        font-size: 12px;
        margin-bottom: 10px;
        padding: 3px 0;
      }

      .van-button {
        height: auto;
        padding: 10px 15px;
        margin-bottom: 8px;
        font-size: 14px;

        .go-text {
          font-size: 17px;
          margin-top: 5px;
        }
      }
    }
  }

  .showSharePopup-header {
    padding: 48px 37px 5px 47px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    span {
      display: block;
      color: #3e3a39;
      line-height: 25px;
    }

    span:first-child {
      font-size: 14px;
    }

    span:not(:first-child) {
      font-size: 17px;
    }

    .showSharePopup-header-image-container {
      position: relative;

      span {
        position: absolute;
        right: 8px;
        top: 8px;
        font-size: 12px;
        color: #9fa0a0;
      }

      img {
        width: 116px;
        height: 116px;
        border: 1px solid #efefef;
        border-radius: 8px;
      }
    }
  }

  .showSharePopup-options-desc {
    font-size: 17px;
    color: #727171;
    padding: 0 0 8px 23px;
  }

  .van-grid-item {
    padding-top: 25% !important;
  }
}
</style>
